import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { rem } from "polished";
import colors from "../../../../utils/colors";
import Icon from "../../../../icons/Icon";
import { ICONS } from "../../../../icons/Icons";

import * as contentActions from "../../../content/content.actions";

import each from "lodash/each";
import sortBy from "lodash/sortBy";
import queryString from "query-string";

import { media } from "../../../../utils/uiSizes";
import { Select } from "../form/index";
import {Localize} from '../../../../locale/localization';

const Container = styled.div`
  position: relative;
  max-width: 940px;
  margin: -1.75rem auto -0.25rem auto;
  padding: 0 2rem;
  text-align: right;

  p {
    font-size: 1rem;
    margin-bottom: 1.25em;
    color: ${colors.GRAY};
  }

  select {
    cursor: pointer;
  }
`;

const Content = styled.div`
  position: absolute;
  top: 0;
  right: 2rem;
  z-index: 2;
  text-align: left;
  opacity: 0;
`;

const IconWrap = styled.div`
  position: relative;
  width: 100%;
  padding-top: 0.5rem;

  span {
    display: inline-block;
    cursor: pointer;
    color: #fff;
    padding-right: 1rem;
    max-width: calc(100% - 4rem);
    vertical-align: middle;
  }
  ${media.tablet`
    padding-top: 0;
  `};
`;

const SearchToolTip = styled.div`
  color: ${colors.WHITE};
  font-size: 1.5rem;
`;

class SearchSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterItems: [],
      selected: ""
    };
  }

  makeTags = tags => {
    let filters = [];
    each(tags, function(item, index) {
      filters.push({
        label: item.label,
        count: item.count
      });
    });

    this.setState({ filterItems: filters });
  };

  componentWillReceiveProps(nextProps) {
    this.makeTags(nextProps.tags);

    const parsed = queryString.parse(window.location.search);
    if (parsed.filter && parsed.filter !== this.state.selected) {
      this.setState({ selected: parsed.filter });
    }
  }

  selectFilter = event => {
    const name = event.target.value;
    this.loadData(name);
  };

  loadData = name => {
    this.updateUrlParameter("filter", name);
    this.setState({ selected: name });

    if (name === "Kaikki" || name === "") {
      const { resetFilter, getContents } = this.props;
      resetFilter();
      getContents();
    } else {
      const { getFilteredContents } = this.props;
      getFilteredContents([name]);
    }
  };

  updateUrlParameter(param, value) {
    let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
    if (value !== "") {
      newUrl += "?" + param + "=" + value;
    }

    window.history.pushState("", "", newUrl);
  }

  getOptions = () => {
    let items = this.state.filterItems;
    items = items.filter(function(i) {
      return i.count > 0;
    });
    items = sortBy(items, ["label"]);

    let options =
      items.length > 0
        ? items.map(op => (
            <option key={op.label} value={op.label}>
              {op.label}
            </option>
          ))
        : null;

    return options;
  };

  getSelectedValue = () => {
    if (this.state.selected !== "") {
      return this.state.selected;
    }
    return "";
  };

  render() {
    return (
      <Container innerRef={r => (this.mainContainer = r)}>
        <IconWrap>
          <SearchToolTip>
          {!this.state.selected && Localize("search")}
        
          <span>{this.state.selected}</span>
          <Icon
            icon={ICONS.SEARCH}
            stroke="none"
            fill={colors.WHITE}
            width={rem("40px")}
            height={rem("40px")}
          />
          </SearchToolTip>
        </IconWrap>
        <Content>
          <Select name="filter" onChange={this.selectFilter} value={this.getSelectedValue()}>
            <option value="">Kaikki</option>
            {this.getOptions()}
          </Select>
        </Content>
      </Container>
    );
  }
}

const ConnectedSearchSelect = connect(null, contentActions)(SearchSelect);

export default ConnectedSearchSelect;



// WEBPACK FOOTER //
// ./src/modules/common/components/app/SearchSelect.js